import { browserHistory } from "react-router";

const goTo = (navigation, destination) => {
  browserHistory.push(destination);
};

export const goHomeWeb = () => {
  browserHistory.push("/");
};

export const goBack = (navigation, destination) => {
  browserHistory.goBack();
};

export default goTo;



// WEBPACK FOOTER //
// ./src/utils/goTo.web.js